import { css } from 'linaria';
import { styled } from 'linaria/react';

export const storageStylesDescription = css`
  margin-bottom: 24px;
`;

export const StorageStyleCard = styled.div`
  display: flex;
  flex-direction: column;
  cursor: pointer;
`;

export const storageStyleImage = css`
  object-fit: cover;
  width: 538px;
  height: 240px;
  border-radius: var(--rounding-l);

  @media (--only-desktop) {
    width: 418px;
  }

  @media (--only-tablet) {
    width: 318px;
  }

  @media (--only-mobile) {
    width: 100%;
    height: 240px;
  }
`;

export const storageStyleCardBottom = css`
  display: flex;
  padding: 16px 0;
  column-gap: 8px;

  @media (--to-desktop) {
    align-items: flex-start;
  }
`;

export const storageStyleCardName = css`
  @media (--from-desktop) {
    white-space: nowrap;
  }

  @media (--only-mobile) {
    margin-right: 8px;
  }
`;

export const storageStyleCardNameIconWrapper = css`
  width: 100%;
`;

export const storageStyleCardNameIcon = css`
  top: 4px;
`;

export const storageStyleCardSlide = css`
  display: flex;

  @media (--to-desktop) {
    flex-direction: column;
  }
`;

export const storageStylesList = css`
  li {
    align-items: flex-start;
    column-gap: 16px;
  }
`;

export const modalMediaCardSwiper = css`
  && {
    width: 100%;
    height: 100%;

    .swiper-button-prev {
      border: none;

      &:hover {
        background-color: var(--control-secondary);
      }
    }

    .swiper-button-next {
      border: none;

      &:hover {
        background-color: var(--control-secondary);
      }
    }

    @media (--to-desktop) {
      padding: 0;
      margin: 0;
    }
  }
`;
